import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button, Box, Grid, Card, CardContent } from '@mui/material';

const HomePage = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
                Welcome to the PBE Data App!
            </Typography>

            {/* TPE Section */}
            <Box sx={{ mb: 6 }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
                    TPE
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    Active Players
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    View current player information including TPE, team assignments, and basic details.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/players"
                                    fullWidth
                                >
                                    View Players
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    Team Information
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Explore team data including total TPE, player counts, and organizational structure.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/teams"
                                    fullWidth
                                >
                                    View Teams
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* Attributes Section */}
            <Box sx={{ mb: 6 }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
                    Attributes
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    All Attributes
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    View all player attributes for both batters and pitchers combined.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/attributes/all"
                                    fullWidth
                                >
                                    View All Attributes
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    Batter Attributes
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Detailed batting attributes including hitting, speed, and fielding metrics.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/attributes/batters"
                                    fullWidth
                                >
                                    View Batter Attributes
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    Pitcher Attributes
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Comprehensive pitching attributes including velocity, movement, and pitch arsenal.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/attributes/pitchers"
                                    fullWidth
                                >
                                    View Pitcher Attributes
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* Statistics Section */}
            <Box sx={{ mb: 6 }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
                    Statistics
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>
                                    Player Statistics
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Comprehensive player statistics including batting, pitching, and fielding data across all seasons.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to="/player-stats"
                                    fullWidth
                                >
                                    View Stats
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default HomePage;